module.exports = __webpack_public_path__ + "static/media/ic-persons.06dcc1f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-persons.svg
// module id = 653
// module chunks = 14